module.exports = __webpack_public_path__ + "ed366ec0a6f43f846aac434ca25c2eed.png";